import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { setDynamicDiscountAction } from 'modules/purchase/redux/actions/common'

export const useDynamicDiscount = () => {
  const { search } = useLocation()
  const dispatch = useDispatch()
  const URLParams = new URLSearchParams(search)
  const utmTagsFromUrl = Object.fromEntries(URLParams.entries())

  useEffect(() => {
    if (
      utmTagsFromUrl.discount_checkout &&
      utmTagsFromUrl.discount_amount &&
      utmTagsFromUrl.discount_name &&
      utmTagsFromUrl.discount_theme
    ) {
      dispatch(
        setDynamicDiscountAction({
          checkout: utmTagsFromUrl.discount_checkout,
          amount: Number(utmTagsFromUrl.discount_amount),
          name: utmTagsFromUrl.discount_name,
          theme: utmTagsFromUrl.discount_theme,
        }),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])
}
